import React from 'react';
import styled from 'styled-components';

const WizardPaso4 = () => {
  return (
    <FaseContainer>
      <Paso className="pasos completado">
        <Circulo className="circulo completado" />
      </Paso>
      <Paso className="pasos completado">
        <Circulo className="circulo completado" />
      </Paso>
      <Paso className="pasos completado">
        <Circulo className="circulo completado" />
      </Paso>
      <Paso className="pasos completado">
        <Circulo className="circulo completado" />
      </Paso>
      <Paso className="pasos active">
        <Circulo className="circulo active" />
      </Paso>
      <div></div>
    </FaseContainer>
  );
};

const FaseContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 50px auto;
`;

const Paso = styled.div`
  position: relative;
  flex: 1;
  text-align: center;
  z-index: 1;

  &:not(:last-child)::after {
    content: '';
    position: absolute;
    top: 50%;
    right: 0;
    width: 100%;
    height: 4px;
    background-color: #d3d3d3;
    z-index: -1;
  }

  &.active::after {    
    background-color: #005a78;
  }

  &.completado::after {
    background-color: #00c4cc;    
  }
`;

const Circulo = styled.div`
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #d3d3d3;
  margin: 5px auto 0 auto;

  &.active {
    background-color: #00547f;
  }

  &.completado {
    background-color: #00CFD4;
  }
`;

export default WizardPaso4;